// Board geometry for RUN THE BLOCK: maps game progress to 15x15 grid cells.
export const TEAMS = ['green', 'blue', 'yellow', 'purple'];
export const CREW = ['enforcer', 'earner', 'connector', 'wildcard'];
export const TEAM_COLOR = { green: '#22C55E', blue: '#3B82F6', yellow: '#EAB308', purple: '#A855F7' };
export const TEAM_ENTRY = { green: 0, blue: 13, yellow: 26, purple: 39 };
export const BASE = -1;
export const HOME = 56;
export const SAFE = new Set([0, 8, 13, 21, 26, 34, 39, 47]);
export const CHECKPOINT = new Set([6, 19, 32, 45]);
export const TERRITORY = new Set([3, 11, 16, 24, 29, 37, 42, 50]);
export const AMBUSH = new Set([10, 23, 36, 49]);

const seg = (cells) => cells;
const range = (a, b) => (a <= b ? Array.from({ length: b - a + 1 }, (_, i) => a + i) : Array.from({ length: a - b + 1 }, (_, i) => a - i));

export const LOOP = [
  ...seg(range(1, 5).map((c) => [6, c])),
  ...seg(range(5, 0).map((r) => [r, 6])),
  [0, 7],
  ...seg(range(0, 5).map((r) => [r, 8])),
  ...seg(range(9, 14).map((c) => [6, c])),
  [7, 14],
  ...seg(range(14, 9).map((c) => [8, c])),
  ...seg(range(9, 14).map((r) => [r, 8])),
  [14, 7],
  ...seg(range(14, 9).map((r) => [r, 6])),
  ...seg(range(5, 0).map((c) => [8, c])),
  [7, 0],
  [6, 0],
];

export const LANES = {
  green: [...range(1, 5).map((c) => [7, c]), [7, 6]],
  blue: [...range(1, 5).map((r) => [r, 7]), [6, 7]],
  yellow: [...range(13, 9).map((c) => [7, c]), [7, 8]],
  purple: [...range(13, 9).map((r) => [r, 7]), [8, 7]],
};

export const BASE_CENTER = { green: [2.5, 2.5], blue: [2.5, 11.5], yellow: [11.5, 11.5], purple: [11.5, 2.5] };
const SLOT = [[-0.85, -0.85], [-0.85, 0.85], [0.85, -0.85], [0.85, 0.85]];

export const tileType = (i, layout) => {
  if (SAFE.has(i)) return 'safe';
  if (!layout) return CHECKPOINT.has(i) ? 'checkpoint' : TERRITORY.has(i) ? 'territory' : AMBUSH.has(i) ? 'ambush' : 'street';
  return ['checkpoint', 'territory', 'ambush'].find((k) => layout[k]?.includes(i)) || 'street';
};

export const loopIndex = (team, progress) => (progress >= 0 && progress <= 50 ? (TEAM_ENTRY[team] + progress) % 52 : null);

// Returns [row, col] center (in cell units, +0.5 already applied) for a piece.
export function cellFor(team, progress, pieceIdx) {
  if (progress === BASE) {
    const [r, c] = BASE_CENTER[team];
    return [r + 0.5 + SLOT[pieceIdx][0], c + 0.5 + SLOT[pieceIdx][1]];
  }
  if (progress <= 50) {
    const [r, c] = LOOP[loopIndex(team, progress)];
    return [r + 0.5, c + 0.5];
  }
  const [r, c] = LANES[team][progress - 51];
  return [r + 0.5, c + 0.5];
}

export function tileKey(team, progress) {
  if (progress === BASE) return `${team}-base`;
  if (progress <= 50) return `L${loopIndex(team, progress)}`;
  return `${team}-lane-${progress}`;
}

// Projection constants shared by CSS and the figure layer.
export const TILT_DEG = 50;
export const PERSPECTIVE = 1800;

export function project(row, col, cell, cx, cy, tilt = TILT_DEG) {
  const half = 7.5 * cell;
  const x = col * cell - half;
  const y = row * cell - half;
  const th = (tilt * Math.PI) / 180;
  const z = y * Math.sin(th);
  const s = PERSPECTIVE / (PERSPECTIVE - z);
  return { x: cx + x * s, y: cy + y * Math.cos(th) * s, s };
}

export const cityBg = (city) => `/rtb/cities/bg_${city || 'brooklyn'}.jpg`;
export const cityPlane = (city) => `/rtb/cities/plane_${city || 'brooklyn'}.jpg`;
export const shade = (url, a = 0.3, b = 0.55) => ({ backgroundImage: `linear-gradient(rgba(6,6,12,${a}), rgba(6,6,12,${b})), url('${url}')` });
